import React from "react";
import { UserPaymentTrancheApi, userPaymentsApi } from "api";
import { PaziaButton, PaziaDateSelect, PaziaFormButton } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { formatDate } from "utils";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

interface PostponePaymentModalProps {
  onCloseRequest: () => void;
  tranche?: UserPaymentTrancheApi;
  userId: number;
  courseId: number;
}
import { useToaster } from "utils";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { ModalPadding } from "components/templates/Modals/ModalPadding";

export const PostponePaymentModal = ({ onCloseRequest, tranche, userId, courseId }: PostponePaymentModalProps) => {
  const { showError, showSuccess } = useToaster();

  const onSubmit = async (data: { newDate: Date }) => {
    try {
      if (!tranche) return;
      await userPaymentsApi.postponePayment(userId, courseId, tranche.courseTrancheId, data.newDate);
      showSuccess("Data płatności została zmieniona");
    } catch (error) {
      console.error(error);
      showError("Wystąpił błąd podczas zmiany daty płatności");
    } finally {
      onCloseRequest();
    }
  };

  return (
    <PaziaModal id="change-payment-status-modal" onCloseRequest={onCloseRequest} isOpen={!!tranche} size="xl">
      {tranche && (
        <ModalPadding>
          <ModalHeader>Odrocz płatność</ModalHeader>
          <div className="flex justify-between">
            <div>Aktualna data płatności</div>
            <div>{formatDate(tranche.dueDate)}</div>
          </div>
          <PostponePaymentForm onSubmit={onSubmit} onCancel={onCloseRequest} currentDueDate={tranche.dueDate} />
        </ModalPadding>
      )}
    </PaziaModal>
  );
};

const PostponePaymentForm = ({
  onSubmit,
  onCancel,
  currentDueDate,
}: {
  onSubmit: (data: { newDate: Date }) => Promise<void>;
  onCancel: () => void;
  currentDueDate: Date;
}) => {
  const schema = yup
    .object({
      newDate: yup.date().required().min(currentDueDate, "Data zakończenia przed rozpoczęciem"),
    })
    .required();
  const methods = useForm({
    resolver: yupResolver(schema),
  });
  const { handleSubmit } = methods;
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-between">
          <div>Nowa data płatności</div>
          <PaziaDateSelect name="newDate" />
        </div>

        <div className="mt-4 flex justify-end gap-2">
          <PaziaButton btnType="button" type="tertiary" onClick={onCancel} title="Anuluj" />
          <PaziaFormButton type="success" title="Zapisz" />
        </div>
      </form>
    </FormProvider>
  );
};
